import styled from "styled-components";
import { Fragment, useState } from "react";
import { Grid, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import pages from "../../../../../constants/pages";
import { colors } from "../../../../css components/Style";
import {
  Autocomplete,
  AutocompleteMultiSelect,
  ComponentHeader,
  FileUpload,
  TextField,
} from "../../../../../components";
import AudienceForm from "../../audience details components/AudienceForm";
import AudienceDetailsDialog from "../../audience details components/AudienceDetailsDailog";
import { PrimaryButton } from "../../../../css components/Button";
import { alert } from "../../../../../redux/slices/alertSlice";
import AudienceLogicPillToggle from "./AudienceLogicPill";

const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Label = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #0234ad;
`;

const Switch = styled.label`
  position: relative;
  display: inline-block;
  width: 52px;
  height: 26px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  input:checked + span {
    background-color: #5a8bf2;
  }

  input:checked + span:before {
    transform: translateX(26px);
  }
`;

const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.3s;
  border-radius: 34px;

  &:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.3s;
    border-radius: 50%;
  }
`;

const AudienceProcessingType = styled(Grid)`
  padding: 10px;
  border: 1px solid #cbcbcb;
  display: flex;
  justify-content: space-between;
  border-radius: 10px;
`;

export default function FormTwo({
  audiences,
  brandIdentity,
  formikProps,
  editState,
  component,
  audienceData,
  setAudienceData,
  audienceSize,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { categories, location, languages } = useSelector(
    (state) => state.memberDetails
  );
  const [details, setDetails] = useState({
    id: formikProps.values.audience,
    state: false,
  });

  function handleChangeProcessing(e) {
    formikProps.setValues((prev) => ({
      ...prev,
      campaignProcessing: e.target.checked,
      audienceMeta: {},
      audiences: [],
      selectedAudiences: [],
    }));
  }

  return (
    <Fragment>
      <Grid sie={12}>
        <ComponentHeader title={"Audience Selection Mode"} />
      </Grid>

      <Grid size={12}>
        <ToggleWrapper>
          <Label>1:1</Label>

          <Switch>
            <input
              disabled={!editState}
              type="checkbox"
              name="isVisible"
              disabled={!editState}
              checked={formikProps.values.campaignProcessing}
              onChange={handleChangeProcessing}
            />
            <Slider />
          </Switch>

          <Label
            style={{
              color: formikProps.values.campaignProcessing ? "#5a8bf2" : "#999",
            }}
          >
            N:N
          </Label>
        </ToggleWrapper>

        <Typography
          sx={{ fontSize: "13px", color: "#808080", marginTop: "10px" }}
        >
          Note : 1:1 Single audience selection mode.
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; N:N
          Multi-audience selection mode with configurable AND/OR logic.
        </Typography>
      </Grid>

      <Grid size={12}>
        <ComponentHeader title={"Audience"} />
      </Grid>

      {!formikProps.values?.campaignID || editState ? (
        <Fragment>
          <Grid size={4}>
            {!formikProps.values.campaignProcessing ? (
              <Autocomplete
                label={"Select Audience"}
                forcePopupIcon={!editState ? false : true}
                name="audienceID"
                defaults={{
                  primaryKey: "audience_id",
                  displayLabel: "audience_group",
                }}
                sx={{
                  "& .MuiSvgIcon-root": {
                    display: !editState && "none",
                  },
                }}
                options={audiences}
                disabled={
                  audienceSize?.values?.audience_params ||
                  audienceSize?.values.audience_size ||
                  (!audienceData.isEditable &&
                    formikProps.values.status === "OFFER_ACCEPTED")
                }
                onChange={(_, value, type) => handleChangeAudience(value, type)}
                formikProps={formikProps}
              />
            ) : (
              <AutocompleteMultiSelect
                required
                label={"Select Audience"}
                forcePopupIcon={!editState ? false : true}
                name="audiences"
                defaults={{
                  primaryKey: "audience_id",
                  displayLabel: "audience_group",
                }}
                options={audiences}
                disabled={!editState}
                onChange={(_, arr, reason, option) =>
                  handleChange(arr, reason, option, "audiences", "audience_id")
                }
                formikProps={formikProps}
              />
            )}

            {formikProps.values.audienceID &&
              !formikProps.values.campaignProcessing && (
                <Grid size={12}>
                  <PrimaryButton
                    size="small"
                    sx={{ margin: "8px 0 0 8px" }}
                    onClick={() =>
                      setDetails({
                        id: formikProps.values.audienceID,
                        state: true,
                        open: "detail",
                      })
                    }
                    variant="outlined"
                  >
                    Audience Details
                  </PrimaryButton>
                </Grid>
              )}

            {(audienceSize?.values?.audience_params ||
              audienceSize?.values.audience_size) &&
              formikProps.values.campaignProcessing && (
                <Typography color={colors.publicisBlue}>
                  NOTE: Once audience size ready can't change audience.
                </Typography>
              )}

            {!brandIdentity &&
              editState &&
              !(
                audienceSize?.values?.audience_params ||
                audienceSize?.values.audience_size
              ) &&
              !formikProps.values.campaignProcessing && (
                <Typography
                  style={{
                    margin: "8px",
                    fontWeight: 500,
                    marginBottom: "8px",
                    display: "flex",
                  }}
                >
                  Can’t find your audience group, let’s &nbsp;
                  <Typography
                    style={{ color: colors.publicisBlue, cursor: "pointer" }}
                    onClick={() => navigate(pages.createAudience.route)}
                  >
                    {" "}
                    create one
                  </Typography>{" "}
                  .
                </Typography>
              )}
          </Grid>

          <Grid size={4}>
            <FileUpload
              label="Upload Additional Campaign Brief"
              name="additional_audience.value"
              formikProps={formikProps}
              disabled={!editState}
              allowedExtension=".pdf,.doc,.docx,.ppt"
              value={formikProps.values.additional_audience?.value
                ?.split("/")
                .pop()
                .slice(
                  formikProps.values?.additional_audience?.value
                    ?.split("/")
                    .pop()
                    .indexOf("_") + 1
                )}
              folderPath={"additional_audience/" + new Date().getTime() + "_"}
            />

            <Typography sx={{ display: "flex", margin: "8px" }}>
              <Typography
                sx={{ cursor: "pointer" }}
                color={colors.growthOSDarkBlue}
                onClick={() => {
                  window.open(
                    "https://adn-media.s3.ap-south-1.amazonaws.com/additional_audience/1759832934689_Brief Template.docx",
                    "_blank"
                  );
                }}
              >
                Download{" "}
              </Typography>{" "}
              &nbsp; Sample Audience File
            </Typography>
          </Grid>
        </Fragment>
      ) : (
        <Fragment>
          {!formikProps.values.campaignProcessing && (
            <Fragment>
              <AudienceForm
                editState={editState}
                audienceData={audienceData}
                categories={categories}
                location={location}
                languages={languages}
                formikProps={formikProps}
                component={component}
                setAudienceData={setAudienceData}
              />

              {formikProps.values.additional_audience?.value && (
                <Grid size={12}>
                  <Typography
                    sx={{
                      cursor: "pointer",
                      fontSize: "16px",
                      color: colors.publicisBlue,
                    }}
                    onClick={() => {
                      window.open(
                        formikProps.values.additional_audience?.value,
                        "_blank"
                      );
                      dispatch(
                        alert({
                          type: "success",
                          message: "Additional fields opened in new tab.",
                        })
                      );
                    }}
                  >
                    View Additional Audience Brief
                  </Typography>
                </Grid>
              )}
            </Fragment>
          )}

          {formikProps.values.campaignProcessing && (
            <Grid size={4}>
              <TextField
                size="small"
                disabled
                value={formikProps.values.selectedAudiences
                  .map((item) => item.audience_group)
                  .join(", ")}
              />
            </Grid>
          )}
        </Fragment>
      )}

      {formikProps.values.campaignProcessing &&
        formikProps.values.selectedAudiences?.length > 0 && (
          <Grid size={12}>
            <ComponentHeader
              title={
                "Audience Group Logic (Individual - Within the Audience Group)"
              }
            />

            <Typography variant="body1" color="#808080">
              Define how conditions within this audience group should be
              evaluated.
            </Typography>
          </Grid>
        )}

      {formikProps.values.selectedAudiences?.map((item) => (
        <AudienceProcessingType size={4}>
          <Typography
            sx={{
              alignSelf: "center",
              fontSize: "15px",
              fontWeight: "500",
              color: colors.publicisBlue,
            }}
          >
            {item.audience_group}
          </Typography>

          <AudienceLogicPillToggle
            audienceData={item}
            editState={editState}
            formikProps={formikProps}
          />
        </AudienceProcessingType>
      ))}

      <AudienceDetailsDialog
        details={details}
        setDetails={setDetails}
        editState={editState}
        formikProps={formikProps}
      />
    </Fragment>
  );

  function handleChange(selectedOptions, reason, option, name, primaryKey) {
    const objectName = name.substring(0, name.indexOf("."));
    let values = [];
    let meta = {};
    for (let obj of selectedOptions) {
      values.push({
        audience_id: obj.audience_id,
        audience_group: obj.audience_group,
      });
      meta[obj.audience_id] = "OR";
    }

    formikProps.setValues((prev) => {
      const updated = {
        ...prev,
        audiences: selectedOptions.map((item) => item[primaryKey]),
        selectedAudiences: values,
        audienceMeta: meta,
      };

      return updated;
    });
  }

  function handleChangeAudience(value, type) {
    if (type === "selectOption") {
      formikProps.setValues((prevVal) => ({
        ...prevVal,
        audienceID: value.audience_id,
      }));

      setDetails({
        id: value.audience_id,
        state: false,
      });
    } else {
      value = {
        audience_id: "",
        audience_group: "",
      };

      formikProps.setValues((prevVal) => ({
        ...prevVal,
        audienceID: value._id,
      }));
    }
  }
}
